// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4828":"607bca69","8445":"d9ebf1ce","8596":"975186db","9099":"607bca69","9345":"607bca69"}[chunkId] + ".chunk.css";
};